import storage from 'store2'
// import expirePlugin from 'store/plugins/expire'
import { login, logout } from '@/api/login'
import { userInfo, setTenant } from '@/api/tenant'
import { ACCESS_TOKEN, USER_INFO } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

// storage.addPlugin(expirePlugin)
const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      // storage.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
      // console.log('此处刷新token了么？', ACCESS_TOKEN, token)
      storage.set(ACCESS_TOKEN, token)
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
      // storage.set(USER_INFO, info)
      storage.session.set(USER_INFO, info)
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const result = response.dataMap.data
          storage.set(ACCESS_TOKEN, result.token, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', result.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        userInfo().then(response => {
          console.log('获取用户信息的接口===>', response)
          if (response.success === 1) {
            const result = response.dataMap.data
            commit('SET_INFO', response.dataMap.data)
            commit('SET_NAME', { name: result.userName, welcome: welcome() })
            commit('SET_ROLES', result.roles)
            resolve(result)
          } else {
            reject(new Error('获取用户信息失败'))
          }
          // const result = response.dataMap.data
          // if (result.roles) {
          // // if (result.role && result.role.permissions.length > 0) {
          //   /* const role = { ...result.role }
          //   role.permissions = result.role.permissions.map(permission => {
          //     const per = {
          //       ...permission,
          //       actionList: (permission.actionEntitySet || {}).map(item => item.action)
          //     }
          //     return per
          //   })
          //   role.permissionList = role.permissions.map(permission => {
          //     return permission.permissionId
          //   }) */
          //   // 覆盖响应体的 role, 供下游使用
          //   // result.role = role
          //
          //   commit('SET_ROLES', result.roles[0])
          //   commit('SET_INFO', result.tenants[0])
          //   commit('SET_NAME', { name: result.tenants[0].name, welcome: welcome() })
          //   commit('SET_AVATAR', result.avatar)
          //   console.log('放到了下游么')
          //   // 下游
          //   resolve(result)
          // } else {
          //   reject(new Error('getInfo: roles must be a non-null array !'))
          // }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          storage.remove(ACCESS_TOKEN)
          // TODO 如果当前处在登录页面则不跳转
          if (location.href.includes('user/login')) {
            resolve()
          }
          location.href = '/user/login'
          resolve()
        }).catch((err) => {
          console.log('logout fail:', err)
          // resolve()
        }).finally(() => {
        })
      })
    },

    // 切换租户
    changeTenant ({ commit, state }, tenantId) {
      return new Promise((resolve, reject) => {
        setTenant({ tenantId }).then(res => {
          if (res.success === 1) {
            resolve()
          } else {
            reject(new Error())
          }
        })
      })
    }

  }
}

export default user
